import { t } from 'i18next'
import { FC } from 'react'
import { useNavigate } from 'react-router-dom'

import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { Box, Button } from '@mui/material'

type BackButtonProps = {
  url?: string
  mb?: number
  text?: string
}
export const BackButton: FC<BackButtonProps> = ({ url, mb = 2, text }) => {
  const navigate = useNavigate()
  return (
    <Box mb={mb}>
      <Button
        variant="outlined"
        startIcon={<ArrowBackIcon />}
        onClick={() => {
          if (url) {
            navigate(url)
          } else {
            navigate(-1)
          }
        }}
      >
        {text ?? t('internal-common:back')}
      </Button>
    </Box>
  )
}
